import { Component, Input, OnInit } from "@angular/core";
import textConfiguration from "../../../../assets/static-text-configuration.json";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-no-license",
  templateUrl: "./no-license.component.html",
  styleUrls: ["./no-license.component.scss"],
})
export class NoLicenseComponent implements OnInit {
  authText: any = (textConfiguration as any).auth;
  @Input() moduleName: any;
  images: any = [];

  constructor(private readonly commonService: CommonService) {}

  ngOnInit(): void {
    this.loadLicensingImages();
    console.log(this.moduleName);
  }

  loadLicensingImages() {
    this.commonService.getLicensingImages(this.moduleName).subscribe({
      next: (imgs: any) => {
        this.images = imgs?.images;
      },
      error: () => {
        this.images = [];
      },
    });
  }
}
